class Tabs {
    constructor(options) {
        this.scope = options.scope;
        this.tabs = options.tabs;
        this.contents = options.contents;
        this.tabActiveClass = options.tabActiveClass;
        this.contentActiveClass = options.contentActiveClass;
        this.activateFirst = options.activateFirst !== false; // default true

        this.bindEvents();
        this.init();
    }

    init() {
        // Only activate the first tab if option is true
        if (this.activateFirst && this.tabs.length > 0 && this.contents.length > 0) {
            this.activateTab(0);
        }
    }

    bindEvents() {
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                this.activateTab(index);
            });
        });
    }

    activateTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle(this.tabActiveClass, i === index);
      });

      this.contents.forEach((content, i) => {
        if (i === index) {
          content.style.display = "flex"; // show immediately
          content.offsetHeight; // force reflow
          window.dispatchEvent(new Event("scroll")); // force lazy loaded images
          content.classList.add(this.contentActiveClass); // fade in
        } else {
          content.classList.remove(this.contentActiveClass); // fade out
          content.style.display = "none"; // hide immediately
        }
      });
    }
}
